<template>
  <v-card
    outlined
    tile
  >
    <v-card-text>
      <v-row>
        <!-- 画像 -->
        <v-col cols="12" sm="6">
          <v-img
            :src="car.image"
            :aspect-ratio="16/9"
          />
        </v-col>

        <!-- サマリ -->
        <v-col cols="12" sm="6">
          <!-- 車両名 -->
          <div class="caption">{{car.maker}}</div>
          <div class="carname" v-html="carname"></div>
          <div class="mt-4">{{car.typeName}}</div>
          <div class="chargeText">{{car.chargeText}}</div>
          <div v-html="summary"></div>
          <div v-html="tags"></div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn class="primary" v-if="car.hasDetails" text :to="availableCar ? {name: 'car', params: {carid: car.id}} : '' " @click="onClick">選択</v-btn>
      <v-btn class="primary" v-else text @click="book">選択</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style>
.carname {
  width: 100%;
  border-bottom: solid 2px #ccc;
}
.carname_span {
  display: inline-block;
  padding: 4px 0;
  font-size: 1.2rem;
  font-color: red;
  text-align: left;
  margin-right: 8px;
}
.chargeText {
  margin-bottom: 8px;
}
.AttributesIcon {
  display: inline-block;
  padding: 2px 4px;
  margin-right: 4px;
  margin-bottom: 4px;
  border-radius: 4px;
}
.Attributes_Dark {
  color: #fff;
}
.Attributes_Bright {
  color: #000;
}
</style>

<script>
import { run } from '@/libs/a'
import * as time from '@/libs/time'

export default {
  name: 'CCar',
  props: {
    stationID: {
      type: Number,
      required: true
    },
    car: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // エラーメッセージ
    errors: [],
    today: time.today()
  }),
  computed: {
    carname () {
      let HTML = '<span class="carname_span">' + this.car.name + '</span>'
      const tags = []

      const attrs = this.car.attributes
      if (attrs.vkey || attrs.keykey) {
        tags.push('24h貸出')
      }

      HTML = HTML + this.tags_html(tags)

      return HTML
    },

    summary () {
      const summary = []

      const attrs = this.car.attributes

      if (attrs.cc > 0) {
        summary.push(`${attrs.cc} cc`)
        // summary.push(`${attrs.cc / 1000} L`)
      }
      if (attrs.fuel) {
        summary.push(attrs.fuel)
      }
      if (attrs.seats > 0) {
        summary.push(`乗車${attrs.seats}名`)
      }
      if (attrs.bed > 0) {
        summary.push(`就寝${attrs.bed}名`)
      }
      if (attrs.days) {
        summary.push(`最大利用 ${attrs.days}日`)
      }

      // return summary.join(' / ')

      return this.tags_html(summary)
    },

    tags () {
      const tags = []

      const attrs = this.car.attributes

      tags.push(attrs.smoke ? '喫煙' : '禁煙')
      tags.push(attrs.mission ? 'MT' : 'AT')
      if (attrs.etc) {
        tags.push('ETC')
      }
      if (attrs.drive === 1) {
        tags.push('4WD')
      }
      if (attrs.navi) {
        tags.push('カーナビ')
      }
      if (attrs.studless) {
        tags.push('スタッドレス可')
      }
      if (attrs.tags) {
        tags.push(...attrs.tags)
      }
      if (attrs.keykey) {
        // tags.push('24h貸出対応')
      }

      // return tags.join(' / ')
      return this.tags_html(tags)
    },

    /**
     * ログインしているか
     */
    authed () {
      return this.getters['user/authed']
    },

    /**
     * 初回利用フラグ
     */
    firstTime () {
      const orgcode = this.getters['org/code']
      if (orgcode === 'sagami-rent') {
        return false
      }
      return this.getters['user/limited'](this.today).firstTime
    },

    /**
     * 24時間利用可能フラグ
     */
    user24Flg () {
      return this.getters['user/keykey']
    },

    /**
     * AT限定フラグ
     */
    licenseAT () {
      return this.getters['user/licenseAT']
    },
    /**
     * 車両利用可能フラグ
     */
    availableCar () {
      return this.isAvailableCar24() && this.isAvailableMT()
    }
  },

  methods: {
    book () {
      if (this.errors.length) {
        alert(this.errors)
        return
      }
      run(async () => {
        await this.dispatch('book/init', {
          stationID: this.stationID,
          car: this.car
        })

        // book に移動
        this.goTo({ name: 'book' })
      })
    },

    font_color_class () {
      let ClassName = ''
      if (this.isDarkColor('primary') === true) {
        ClassName = 'Attributes_Dark'
      } else {
        ClassName = 'Attributes_Bright'
      }
      // 暫定で
      ClassName = 'Attributes_Dark'
      return ClassName
    },

    tags_html (tags) {
      // 配列かどうか
      if (Array.isArray(tags)) {
      } else {
        return
      }

      // テーマ色設定
      const FontColor = this.font_color_class()
      const SpanTag = '<span class="AttributesIcon ' + FontColor + ' primary">'

      // HTMLタグに変換
      let HTML = ''
      for (let i = 0; i < tags.length; i++) {
        HTML = HTML + SpanTag + tags[i] + '</span>'
      }

      return HTML
    },

    isAvailableCar24 () {
      let isAbailable = true
      const attrs = this.car.attributes
      if (attrs.vkey || attrs.keykey) { // 24時間対応車両
        if (!this.authed) { // 未ログイン状態
          this.errors = ['24時間車両は、ログインしてからご利用ください']
          isAbailable = false
        } else if (this.firstTime) { // 初回利用時
          this.errors = ['24時間車両は、初回利用のお客様はご利用いただけません']
          isAbailable = false
        } else if (!this.user24Flg) { // 24時間車両利用不可
          this.errors = ['お客様は24時間車両がご利用できないステータスになっております']
          isAbailable = false
        }
      }
      return isAbailable
    },
    isAvailableMT () {
      let isAbailable = true
      const attrs = this.car.attributes
      if (this.licenseAT && attrs.mission) {
        this.errors.push(['お客様はAT限定免許の為、MT車の予約はできません'])
        isAbailable = false
      }
      return isAbailable
    },
    onClick () {
      if (this.errors.length) {
        alert(this.errors)
      }
    }
  }
}
</script>
